/** @format */

import React, { useState, useCallback, useRef } from "react";
// @ts-ignore
import { Helmet, HelmetProvider } from "react-helmet-async";
import { createUseStyles } from "react-jss";
import { ThemeType } from "../styles/theme";
// import { categoryData, faqData } from "../constants/FaqData";
import CategoryButton from "../components/FaqPage/CategoryButton";
import { CategoryData, FaqData } from "../types";
import searchIcon from "../assets/searchBlack@2x.png";
import resultNoneImg from "../assets/feedbackFaqNon@2x.png";
import { RefObject } from "react";
import { withVersionParams } from "../HOC/withVersionParams";
import List from "../components/Common/List";
import FaqItem from "../components/FaqPage/FaqItem";
import { categoryData, faqData } from "../constants/FaqData";
const useStyles = createUseStyles((theme: ThemeType) => ({
   wrap: {
      width: "100%",
   },
   input: {
      backgroundColor: theme.monoBg,
      background: `url(${searchIcon}) no-repeat 20px 19px`,
      backgroundSize: "22px auto",
      padding: "15px 20px 17px 50px",
      "& > input": {
         fontSize: "1.8rem",
         width: "100%",
         lineHeight: "2.8rem",
         color: theme.mono0,
         "&::placeholder": {
            color: theme.monoDim,
         },
      },
   },
   categoryList: {
      padding: "30px 20px 10px",
      "& > div": {
         display: "inline-block",
      },
   },
   none: {
      width: "100%",
      height: "calc(100vh - 120px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
   },
   none__box: {
      textAlign: "center",
      "& > img": {
         marginBottom: 16,
      },
      "& > p": {
         fontSize: "1.8rem",
      },
   },
}));

interface Props {
   faqData: FaqData[];
   categoryData: CategoryData;
}

const FaqPage: React.FC = () => {
   const classes = useStyles();
   const [keyword, setKeyword] = useState<string>("");
   const keywordRef = useRef<HTMLInputElement>();

   const [selectedIdx, setIdx] = useState<number>(-1);
   const toggleItem = useCallback(
      (idx: number) => {
         setIdx(selectedIdx !== idx ? idx : -1);
      },
      [selectedIdx]
   );
   const [selectedCategory, setCategory] = useState<number>(0);
   const [filteredData, setFilteredData] = useState<FaqData[]>(
      faqData.filter((item) => item.isFrequent)
   );

   const _filterData = useCallback(
      (keyword: string, selectedCategory: number) => {
         setIdx(-1);

         if (!!keyword) {
            setFilteredData(
               faqData.filter((item) =>
                  new RegExp(keyword, "i").test(item.title)
               )
            );
            return;
         }

         if (selectedCategory === 0) {
            setFilteredData(faqData.filter((item) => item.isFrequent));
            return;
         }

         setFilteredData(
            faqData.filter((item) => item.category === selectedCategory)
         );
      },
      []
   );

   const handleKeyPress = useCallback(
      (e: any) => {
         const _value = e.target.value;
         const key =
            e.key === "Unidentified" ? _value[_value.length - 1] : e.key;
         if (key === "Enter") {
            _filterData(keyword, selectedCategory);
            (keywordRef.current as HTMLInputElement).blur();
         }
      },
      [_filterData, keyword, selectedCategory]
   );

   return (
      <>
         <HelmetProvider>
            <Helmet>
               <title>FAQ</title>
            </Helmet>
         </HelmetProvider>
         <div className={classes.wrap}>
            <div className={classes.input}>
               <input
                  type="text"
                  value={keyword}
                  onChange={(e) => {
                     if (!e.target.value) {
                        _filterData(e.target.value, selectedCategory);
                     }
                     setKeyword(e.target.value);
                  }}
                  onBlur={() => _filterData(keyword, selectedCategory)}
                  onKeyPress={(e) => handleKeyPress(e)}
                  ref={keywordRef as RefObject<HTMLInputElement>}
                  placeholder="궁금한 것을 바로 검색해보세요"
               />
            </div>
            {!keyword && (
               <div className={classes.categoryList}>
                  {Object.values(categoryData)
                     .sort(
                        (a: CategoryData, b: CategoryData) => a.order - b.order
                     )
                     .map((category) => {
                        return (
                           <div
                              onClick={() => {
                                 setCategory(category.id);
                                 _filterData(keyword, category.id);
                              }}
                           >
                              <CategoryButton
                                 category={category}
                                 isClicked={selectedCategory === category.id}
                              />
                           </div>
                        );
                     })}
               </div>
            )}
            {filteredData.length > 0 ? (
               <List
                  data={filteredData}
                  itemComponent={FaqItem}
                  toggleItem={toggleItem}
                  selectedIdx={selectedIdx}
               />
            ) : (
               <div className={classes.none}>
                  <div className={classes.none__box}>
                     <img
                        src={resultNoneImg}
                        alt="검색 결과가 없습니다"
                        width="228"
                        height="140"
                     />
                     <p>검색 결과가 없습니다</p>
                  </div>
               </div>
            )}
         </div>
      </>
   );
};

export default withVersionParams(FaqPage);
